import { Outlet } from 'react-router-dom'
import { Header } from './Header'
import { usePageTitle } from '@/hooks/usePageTitle'

export function Layout() {
  // 페이지 타이틀 자동 업데이트
  usePageTitle()

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="px-4 py-4 pb-8">
        <Outlet />
      </main>
    </div>
  )
}


